/**
 * Default configuration for utilites.
 * @module Configuration
 */

const path = require("path");
const os = require("os");

// where the root data folder is for the G2 installation:

const paths = {
  // istanbul ignore next
  senseDataPath: path.resolve(process.env.ALLUSERSPROFILE || path.join(os.homedir(), "Library"), "Qlik/Sense"),
  senseDesktopPath: path.resolve(os.homedir(), "Documents/Qlik/Sense")
};

module.exports = { paths };
